export default __webpack_public_path__ + "static/media/eco-sub-image-03.20cf53d6.png";